// api.js

import axios from "axios";
const apiDomain = process.env.REACT_APP_API_URL;

const api = {
  url: apiDomain,
  cookieDomain: apiDomain.replace(/https?:\/\/(api||app)?/,"").replace(/:\d+$/,""),  // `.vetmanaged.com` or `.vetmanaged.loc`.  // prefix `.` shares cookie between root & subdomains ('app.' or 'api.' is removed).

  login:                    "/a/api/login",    // POST
  logout:                   "/a/api/logout",   // POST
  session:                  "/a/api/me",

  organizations:            "/a/api/organizations",
  organization:             "/a/api/organization/{organization_id}",
  organizationCreate:       "/a/api/organization/create",
  organizationUpdate:       "/a/api/organization/update",
  organizationDisable:      "/a/api/organization/disable",
  organizationEnable:       "/a/api/organization/enable",
  organizationDelete:       "/a/api/organization/delete",

  orgLocations:             "/a/api/locations/{organization_id}",
  orgStaff:                 "/a/api/staff/{organization_id}",
};

// Axios config & shims for added convenience

const axiosConfig = {
  baseURL: apiDomain,
  timeout: 5000,
  headers: {
    "Accept": "application/json",
    "Content-Type": "application/x-www-form-urlencoded",   // for POST only. This is ignored in GET requests.
    // "_ts": (new Date()).toISOString(),             // ⬅ This is causing preflight and it's being cors rejected. Use cookie set at login instead.
    // "_tz": (new Date()).getTimezoneOffset()/60,    // ⬅ This is causing preflight and it's being cors rejected. Use cookie set at login instead.
    // "Referrer-Policy": "strict-origin-when-cross-origin",
    // "Referrer-Policy": "no-referrer-when-downgrade",
  },
  withCredentials: true,
  exposedHeaders: ["Set-Cookie", "set-cookie"]
};

// Rewrite .get with a more friendly async/await raw awaited passthrough.
axios._get = axios.get;
axios.get = async (apiUrl, config) => {
  const useConfig = {...axiosConfig, ...config};
  try {
    const axConfig = { url: apiUrl, method: "get", ...useConfig };
    const resp = await axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

// Rewrite .post with a more friendly async/await raw awaited passthrough.
axios._post = axios.post;
axios.post = (apiUrl, postData, config) => {
  const useConfig = {...axiosConfig, ...config};
  try {
    const axConfig = { url: apiUrl, method: "post", data: postData, ...useConfig };
    const resp = axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

// Rewrite .post with a more friendly async/await raw awaited passthrough.
axios._post = axios.post;
axios.put = (apiUrl, postData, config) => {
  const useConfig = {...axiosConfig, ...config};
  try {
    const axConfig = { url: apiUrl, method: "put", data: postData, ...useConfig };
    const resp = axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

// Rewrite .put with a more friendly async/await raw awaited passthrough.
// const axiosFormDataConfig = {
//   baseURL: apiDomain,  // This gets ignored if the 'apiUrl' below is a complete URL.
//   timeout: 6000000,
//   headers: {
//     "Accept": "application/json",
//     "Content-Type": "multipart/x-www-form-urlencoded"   // for POST only. This is ignored in GET requests.
//   },
//   withCredentials: true,
//   exposedHeaders: ["Set-Cookie", "set-cookie"]
// };

const axiosFormDataConfig = JSON.parse(JSON.stringify(axiosConfig))
axiosFormDataConfig.timeout = 6000000;

axios.postFile = (apiUrl, formData, onUploadProgressCallback, config) => {
  const useConfig = {...axiosFormDataConfig, ...config};
  if (!!onUploadProgressCallback && typeof(onUploadProgressCallback)==="function") {
    useConfig.onUploadProgress = onUploadProgressCallback;
  }
  try {
    const axConfig = { url: apiUrl, method: "post", data: formData, ...useConfig };
    const resp = axios(axConfig);
    return resp;
  } catch (err) {
    return err;
  }
};

export {
  api,
  axios
};